/* src/app/umbrella-common/components/review-decline-dialog/review-decline-dialog.scss */
.decline-dialog {
  max-width: 600px;
  height: 419px;
  padding: 50px !important;
  overflow: hidden;
}
.decline-dialog h2 {
  margin-top: 0;
}
.decline-dialog label {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
}
.decline-dialog textarea.reason {
  margin-top: 7px !important;
}
.decline-dialog .reason-row {
  margin-bottom: 40px;
}
.decline-dialog .buttons-row {
  float: right;
}
.decline-dialog .buttons-row :last-child {
  margin-left: 40px;
}
/*# sourceMappingURL=review-decline-dialog.css.map */
